import React, {useState, useEffect, useRef} from 'react';
import post from '../utils/post.js';
import AppHeader from '../components/AppHeader.js';
import Search from '../components/Search.js';
import WorkoutOfficNew from '../components/WorkoutOfficNew.js';
import WorkoutOfficEdit from '../components/WorkoutOfficEdit.js';

export default function WorkoutOffic({usrInfo, timerCnt}) {
	const [loading, setLoading] = useState(false);
	const [data, setData] = useState([]);
	const [dataDetail, setDataDetail] = useState({});
	const [showNew, setShowNew] = useState(false);
	const [showEdit, setShowEdit] = useState(false);
	const [searchValue, setSearchValue] = useState('');
	const offsetRef = useRef(0);
	const [loadedCnt, setLoadedCnt] = useState(0);

	useEffect(() => {
		getData('', 0);
	}, []);

	const matchesSearch = (name, search) => {
		if ((search || '').trim() === '') {
			return true;
		}

		return (name || '').toLowerCase().includes(search.trim().toLowerCase());
	};

	const getData = (search, nextOffset = 0) => {
		setLoading(true);

		post('getListWorkoutOffic', {search: search, offset: nextOffset})
			.then((res) => {
				if (nextOffset === 0) {
					setData(res.data);
				} else {
					setData((prevRows) => [...prevRows, ...res.data]);
				}

				setLoadedCnt(res.data.length);
				setLoading(false);
			})
			.catch((error) => {
				console.error(error);
				setLoading(false);
			});
	};

	const handleNew = () => {
		setShowNew(true);
	};

	const closeNew = () => {
		setShowNew(false);
	};

	const updateWorkoutOfficRowNew = (row) => {
		if (!matchesSearch(row.NAME, searchValue)) {
			return;
		}

		setData((prevRows) => [row, ...prevRows]);
	};

	const handleEdit = (rec) => {
		setShowEdit(true);
		setDataDetail(rec);
	};

	const closeEdit = () => {
		setShowEdit(false);
	};

	const updateWorkoutOfficRowEdit = (row) => {
		setData((prevRows) => {
			if (!matchesSearch(row.NAME, searchValue)) {
				return prevRows.filter((item) => item.ID !== row.ID);
			}

			return prevRows.map((item) => {
				if (item.ID === row.ID) {
					return row;
				}

				return item;
			});
		});
	};

	const updateWorkoutOfficRowDelete = (row) => {
		setData((prevRows) => prevRows.filter((item) => item.ID !== row));
	};

	const loadNext = () => {
		const nextOffset = offsetRef.current + usrInfo.LIST_ROWS;
		offsetRef.current = nextOffset;
		getData(searchValue, nextOffset);
	};

	const onChangeSearch = (value) => {
		setSearchValue(value);
		offsetRef.current = 0;
		getData(value, 0);
	};

	const list = data.map((item, index) => {
		return (
			<div className="workoutoffic-page__row" key={'item_' + index}>
				<div className="workoutoffic-page__row-main">
					<div className="workoutoffic-page__row-text">
						<div className="workoutoffic-page__row-name">{item.NAME}</div>
					</div>
				</div>
				<button type="button" className="workoutoffic-page__icon-button" onClick={() => handleEdit(item)} aria-label={`Upravit cvik ${item.NAME}`}>
					<img className="icon1 edit" alt="" />
				</button>
			</div>
		);
	});

	return (
		<>
			<div className="page_main">
				<AppHeader usrInfo={usrInfo} timerCnt={timerCnt} loading={loading} />
				<Search showNew handleNew={handleNew} showSearch searchValue={searchValue} onChangeSearch={(value) => onChangeSearch(value)} />
				<WorkoutOfficNew showNew={showNew} closeNew={closeNew} updateWorkoutOfficRowNew={updateWorkoutOfficRowNew} />
				<WorkoutOfficEdit showEdit={showEdit} closeEdit={closeEdit} updateWorkoutOfficRowEdit={updateWorkoutOfficRowEdit} updateWorkoutOfficRowDelete={updateWorkoutOfficRowDelete} data={dataDetail} />

				<div className={`page workoutoffic-page${usrInfo.sysAdmin === 1 || usrInfo.manager === 1 || usrInfo.instructor === 1 ? ' more' : ''}`}>
					<section className="workoutoffic-page__section">
						<div className="workoutoffic-page__section-head">
							<h2 className="workoutoffic-page__section-title">Seznam cviků</h2>
						</div>

						<div className="workoutoffic-page__list">
							{list.length > 0 ? list : <div className="workoutoffic-page__empty">Žádné oficiální cviky neodpovídají aktuálnímu filtru.</div>}
						</div>

						<div className="workoutoffic-page__load-more">
							{parseInt(loadedCnt, 10) === parseInt(usrInfo.LIST_ROWS, 10) ? (
								<button className="button small loadNext workoutoffic-page__button" onClick={() => loadNext()} disabled={loading}>
									Načíst další
								</button>
							) : (
								<span className="fnt_12 loadNext workoutoffic-page__load-all">Byly načteny všechny záznamy</span>
							)}
						</div>
					</section>
				</div>
			</div>
		</>
	);
}
